"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Metaform REST API
 * REST API for Metaform
 *
 * The version of the OpenAPI document: 2.1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
const runtime_1 = require("../runtime");
const _1 = require("./");
function EmailNotificationFromJSON(json) {
    return EmailNotificationFromJSONTyped(json, false);
}
exports.EmailNotificationFromJSON = EmailNotificationFromJSON;
function EmailNotificationFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'id': !runtime_1.exists(json, 'id') ? undefined : json['id'],
        'subjectTemplate': json['subjectTemplate'],
        'contentTemplate': json['contentTemplate'],
        'emails': json['emails'],
        'notifyIf': !runtime_1.exists(json, 'notifyIf') ? undefined : _1.FieldRuleFromJSON(json['notifyIf']),
    };
}
exports.EmailNotificationFromJSONTyped = EmailNotificationFromJSONTyped;
function EmailNotificationToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'id': value.id,
        'subjectTemplate': value.subjectTemplate,
        'contentTemplate': value.contentTemplate,
        'emails': value.emails,
        'notifyIf': _1.FieldRuleToJSON(value.notifyIf),
    };
}
exports.EmailNotificationToJSON = EmailNotificationToJSON;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiRW1haWxOb3RpZmljYXRpb24uanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi8uLi8uLi9zcmMvZ2VuZXJhdGVkL2NsaWVudC9tb2RlbHMvRW1haWxOb3RpZmljYXRpb24udHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IjtBQUFBLG9CQUFvQjtBQUNwQixvQkFBb0I7QUFDcEI7Ozs7Ozs7Ozs7R0FVRzs7QUFFSCx3Q0FBK0M7QUFDL0MseUJBS1k7QUF3Q1osU0FBZ0IseUJBQXlCLENBQUMsSUFBUztJQUMvQyxPQUFPLDhCQUE4QixDQUFDLElBQUksRUFBRSxLQUFLLENBQUMsQ0FBQztBQUN2RCxDQUFDO0FBRkQsOERBRUM7QUFFRCxTQUFnQiw4QkFBOEIsQ0FBQyxJQUFTLEVBQUUsbUJBQTRCO0lBQ2xGLElBQUksQ0FBQyxJQUFJLEtBQUssU0FBUyxDQUFDLElBQUksQ0FBQyxJQUFJLEtBQUssSUFBSSxDQUFDLEVBQUU7UUFDekMsT0FBTyxJQUFJLENBQUM7S0FDZjtJQUNELE9BQU87UUFFSCxJQUFJLEVBQUUsQ0FBQyxnQkFBTSxDQUFDLElBQUksRUFBRSxJQUFJLENBQUMsQ0FBQyxDQUFDLENBQUMsU0FBUyxDQUFDLENBQUMsQ0FBQyxJQUFJLENBQUMsSUFBSSxDQUFDO1FBQ2xELGlCQUFpQixFQUFFLElBQUksQ0FBQyxpQkFBaUIsQ0FBQztRQUMxQyxpQkFBaUIsRUFBRSxJQUFJLENBQUMsaUJBQWlCLENBQUM7UUFDMUMsUUFBUSxFQUFFLElBQUksQ0FBQyxRQUFRLENBQUM7UUFDeEIsVUFBVSxFQUFFLENBQUMsZ0JBQU0sQ0FBQyxJQUFJLEVBQUUsVUFBVSxDQUFDLENBQUMsQ0FBQyxDQUFDLFNBQVMsQ0FBQyxDQUFDLENBQUMsb0JBQWlCLENBQUMsSUFBSSxDQUFDLFVBQVUsQ0FBQyxDQUFDO0tBQzFGLENBQUM7QUFDTixDQUFDO0FBWkQsd0VBWUM7QUFFRCxTQUFnQix1QkFBdUIsQ0FBQyxLQUFnQztJQUNwRSxJQUFJLEtBQUssS0FBSyxTQUFTLEVBQUU7UUFDckIsT0FBTyxTQUFTLENBQUM7S0FDcEI7SUFDRCxJQUFJLEtBQUssS0FBSyxJQUFJLEVBQUU7UUFDaEIsT0FBTyxJQUFJLENBQUM7S0FDZjtJQUNELE9BQU87UUFFSCxJQUFJLEVBQUUsS0FBSyxDQUFDLEVBQUU7UUFDZCxpQkFBaUIsRUFBRSxLQUFLLENBQUMsZUFBZTtRQUN4QyxpQkFBaUIsRUFBRSxLQUFLLENBQUMsZUFBZTtRQUN4QyxRQUFRLEVBQUUsS0FBSyxDQUFDLE1BQU07UUFDdEIsVUFBVSxFQUFFLGtCQUFlLENBQUMsS0FBSyxDQUFDLFFBQVEsQ0FBQztLQUM5QyxDQUFDO0FBQ04sQ0FBQztBQWZELDBEQWVDIn0=